import LinkButton from 'flarum/common/components/LinkButton';
import Mithril from 'mithril';

export default class TopNavButton extends LinkButton {

    static initAttrs(attrs) {
        super.initAttrs(attrs);
        attrs.class = 'Button Button--flat TopNavButton';
    }

    /**
     * Get the template for the button's content.
     * @param {Mithril.Children} children
     * @return Mithril.ChildArray
     */
    getButtonContent(children) {
        const childItems = super.getButtonContent(children);
        if (this.attrs.badge) {
            const badgeText = this.attrs.badge > 99 ? '99+' : this.attrs.badge;
            childItems.push(<span className="secondary-badge">{badgeText}</span>);
        }
        return childItems;
    }
}
